import useWaitingRoom from './useWaitingRoom';

export default useWaitingRoom;
